import { ICellRendererParams } from 'ag-grid-community';
import { AddOnDataModel } from '../../../models/grid.model';
import { PlanModel } from '../../../models/plans.model';
import { RechargeStatus } from '../../../models/transaction-history.model';
import { UtilityService } from '../../../services/UtilityService';

interface IProps extends ICellRendererParams, AddOnDataModel {
}

export const AddOnRenderer = (props: IProps) => {

    return (
        <div className='d-flex flex-direction justify-between py-1'>
            {props.Data.map((x: PlanModel) =>
                <div>
                    <props.Icon className={"my-auto mr-1"} />
                    <span>{x.Name}
                        <span className='color-vigenary-light'> x{UtilityService.maskSingleDigitWithZero(props.Number.Plans.filter(y => y.PlanID === x.PlanID && y.StatusType === RechargeStatus.ONGOING).length)}</span>
                    </span>
                </div>
            )}
        </div>
    );

};